<template>
  <div class="hero section-type-s bground-config-clean presentation">
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
  <main class="container fonfoBlanco" >
    <div class="mb-4 text-white rounded bg-dark">
      <div class="col-md-12">
        <img src="https://www.premierchevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/certified-service/01-images/feb-servicio-certificado-masthead-lg.jpg?imwidth=960" style="width: 100%;">
      </div>
    </div>

    <div class="col-md-12 mb-5">
     <div class="container mx-auto text-center">
        <h1 class="mt-5 ">Tu seguridad es lo más importante para nosotros, por eso contamos con los mejores especialistas para el cuidado de tu Chevrolet</h1>
      </div>
    </div>

     <div class="mb-4 text-white rounded bg-dark">
      <div class="col-md-12">
        <img src="https://www.premierchevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/certified-service/01-images/sc-valor-desktop.jpg?imwidth=1800" style="width: 100%;">
      </div>
    </div>

    <div class="row py-lg-5">
      <div class="col-lg-6 col-md-8 mx-auto">
        <h1 class="fw-light "> Precios de Servicio 2021 </h1>
      </div>
    </div>

    <div class="row py-lg-5">
      <div class="col-lg-6 col-md-8 mx-auto">
        <h5 class="fw-light "> ¿CUÁNTO TIEMPO TIENES CON TU CHEVROLET? </h5>
        <h1 class="lead text-muted">ASISTENCIA PERSONALIZADA Y CUIDADOS ADICIONALES DE CHEVROLET SERVICIO CERTIFICADO</h1>
      </div>
    </div>
    <div class="text-white rounded bg-dark mb-10">
      <div class="col-md-12">
        <nav>
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <button class="nav-link  active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true" style="max-width: 16.5%">6 MESES O 6 MIL KM</button>
            <button class="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false" style="max-width: 16.5%;">12 MESES O 12 MIL KM</button>
            <button class="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false" style="max-width: 16.5%;">24 MESES O 24 MIL KM</button>
            <button class="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact36" type="button" role="tab" aria-controls="nav-contact36" aria-selected="false" style="max-width: 16.5%;">36 MESES O 36 MIL KM</button>
            <button class="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact48" type="button" role="tab" aria-controls="nav-contact48" aria-selected="false" style="max-width: 16.5%;">48 MESES O 48 MIL KM</button>
            <button class="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact5" type="button" role="tab" aria-controls="nav-contact5" aria-selected="false" style="max-width: 16.5%;">MÁS DE 5 AÑOS</button>
          </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
          <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
            <h1>1donde</h1>
            <img src="https://www.premierchevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/certified-service/01-images/sc-navtab-desktop-6-meses.jpg?imwidth=1800" style="width: 100%;">
          </div>
          <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
             <h1>2donde</h1>
            <img src="https://www.premierchevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/certified-service/01-images/sc-navtab-desktop-12-meses.jpg?imwidth=1800" style="width: 100%;">
          </div>
          <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
             <h1>3donde</h1>
            <img src="https://www.premierchevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/certified-service/01-images/sc-navtab-desktop-24-meses.jpg?imwidth=1800" style="width: 100%;">
          </div>
           <div class="tab-pane fade" id="nav-contact36" role="tabpanel" aria-labelledby="nav-contact36-tab">
              <h1>4donde</h1>
            <img src="https://www.premierchevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/certified-service/01-images/sc-navtab-desktop-36-meses.jpg?imwidth=1800" style="width: 100%;">
          </div>
           <div class="tab-pane fade" id="nav-contact48" role="tabpanel" aria-labelledby="nav-contact48-tab">
              <h1>5donde</h1>
            <img src="https://www.premierchevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/certified-service/01-images/sc-navtab-desktop-48-meses.jpg?imwidth=1800" style="width: 100%;">
          </div>
          <div class="tab-pane fade" id="nav-contact60" role="tabpanel" aria-labelledby="nav-contact60-tab">
             <h1>donde</h1>
            <img src="https://www.premierchevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/certified-service/01-images/sc-navtab-desktop-60-meses.jpg?imwidth=1800" style="width: 100%;">
          </div>
          <div class="tab-pane fade" id="nav-contact5" role="tabpanel" aria-labelledby="nav-contact5-tab">
             <h1>donde</h1>
            <img src="https://www.premierchevrolet.com.mx/content/dam/chevrolet/na/mx/es/index/certified-service/01-images/sc-navtab-desktop-mas-5.jpg?imwidth=1800" style="width: 100%;">
          </div>
        </div>
      </div>
    </div>
  </main>
   <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
  </div>
</template>

<script>
export default {
  name: 'Nosotros'
}
</script>

<style scoped>
  .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
      background-color: #313667;
      border-color: #dee2e600;
  }
  .fonfoBlanco {
    background: url(https://www.toptal.com/designers/subtlepatterns/patterns/interlaced.png);
    padding-top: 16px;
    padding-bottom: 16px;
  }

</style>
